import { tns } from 'tiny-slider/src/tiny-slider';

class LogosSlider {
	constructor(el, nav) {
		this.el = el;
		this.nav = nav;

		const logosSlider = tns({
			container: this.el,
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: false,
			gutter: 20,
			items: 1, // Display 6 logos per slide
			slideBy: "page", // Slide by "page" to ensure 6 items slide at once
			nav: true, // Pagination with dots
			navPosition: "bottom",
			navContainer: this.nav
		});

		return logosSlider;
	}
}

export default LogosSlider;
